import { apiRequest } from './client'

/**
 * Web → API client for the local-password reset endpoints.
 *
 * Mirrors `services/api/src/routes/auth_password.py`. All three calls
 * post JSON and surface the unwrapped envelope `data` field. ApiError
 * is thrown on non-2xx (the call site decides whether to render a
 * field-level error or a toast).
 */

export interface ChangePasswordInput {
  currentPassword: string
  newPassword: string
}

export async function changeOwnPassword(input: ChangePasswordInput): Promise<void> {
  await apiRequest<null>('/api/v1/auth/password/change', {
    method: 'POST',
    body: input,
  })
}

export interface HrResetPasswordResult {
  employeeId: string
  tempPassword: string
  mustChangeAtNextLogin: boolean
}

export function hrResetPassword(employeeId: string): Promise<HrResetPasswordResult> {
  return apiRequest<HrResetPasswordResult>('/api/v1/auth/password/reset', {
    method: 'POST',
    body: { employeeId },
  })
}

export interface HrForceChangeResult {
  employeeId: string
  mustChangeAtNextLogin: boolean
}

export function hrForcePasswordChange(employeeId: string): Promise<HrForceChangeResult> {
  return apiRequest<HrForceChangeResult>('/api/v1/auth/password/force-change', {
    method: 'POST',
    body: { employeeId },
  })
}
